import React, { FC, lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { EntryRouter, EntryRoute } from 'Pages/root'

const LandingCredits = lazy(() => import('Pages/landings/credits'))
const LandingSelfEmployed = lazy(() => import('Pages/landings/newLandings/selfEmployed'))
const LandingSalaryProject = lazy(() => import('Pages/landings/newLandings/salaryProject'))
const LandingAcquiring = lazy(() => import('Pages/landings/newLandings/acquiring'))
const LandingNotary = lazy(() => import('Pages/landings/newLandings/notary'))
const LandingInfo = lazy(() => import('Pages/landings/info'))
const LandingProducts = lazy(() => import('Pages/landings/newLandings/products'))
const LandingMulti = lazy(() => import('Pages/landings/newLandings/multilanding'))
// const LandingPartnerForm = lazy(() => import('Pages/landings/newLandings/partnerForm'))

const Landings: FC = () => {
	return (
		<EntryRouter>
			<EntryRoute lazyComponent={LandingCredits} path={FrontUrls.landing.credits} />
			<EntryRoute lazyComponent={LandingSelfEmployed} path={FrontUrls.landing.self_employed} />
			<EntryRoute lazyComponent={LandingSalaryProject} path={FrontUrls.landing.salary_project} />
			<EntryRoute lazyComponent={LandingAcquiring} path={FrontUrls.landing.acquiring} />
			<EntryRoute lazyComponent={LandingNotary} path={FrontUrls.landing.notary} />
			{/* <EntryRoute lazyComponent={LandingPartnerForm} path={FrontUrls.landing.partnerForm} />*/}
			<EntryRoute lazyComponent={LandingInfo} path={FrontUrls.landing.info} />
			<EntryRoute lazyComponent={LandingProducts} path={FrontUrls.landing.product} />
			<EntryRoute lazyComponent={LandingMulti} path={FrontUrls.landing.multi} />
		</EntryRouter>
	)
}

export default Landings
